import React from 'react'
import { IIconProps } from 'Interfaces'

export function CheckIcon(props: IIconProps) {
    return (
        <svg width={props.width ?? 12} height={props.height ?? 11} viewBox='0 0 12 11' fill='none'>
            <path d="M11.9077 1.5846L5.44617 9.89229C5.35387 9.9846 5.26156 10.0769 5.1231 10.0769C5.1231 10.0769 5.1231 10.0769 5.07694 10.0769C4.93848 10.0769 4.84617 10.0308 4.75387 9.93845L1.06156 6.24614C0.876942 6.06152 0.876942 5.7846 1.06156 5.59999C1.24617 5.41537 1.5231 5.41537 1.70771 5.59999L5.03079 8.92306L11.1693 1.03076C11.3077 0.846141 11.6308 0.799987 11.8154 0.938448C12 1.07691 12.0462 1.39999 11.9077 1.5846Z" fill="currentColor"/>
        </svg>
    )
}